import { render, staticRenderFns } from "./AlcoholAlert.vue?vue&type=template&id=191880aa"
import script from "./AlcoholAlert.vue?vue&type=script&lang=ts"
export * from "./AlcoholAlert.vue?vue&type=script&lang=ts"
import style0 from "./AlcoholAlert.vue?vue&type=style&index=0&id=191880aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports